package com.wintermar.inspection.core.ui.component

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.TextThemeColor

@Composable
private fun AppText(
    text: String,
    style: TextStyle,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    val resolvedColor = color(LocalAppTheme.current.color.text)
    Text(
        text = text,
        color = resolvedColor,
        style = style
            .copy(fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal),
        modifier = modifier,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
private fun AppText(
    text: AnnotatedString,
    style: TextStyle,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    val resolvedColor = color(LocalAppTheme.current.color.text)
    Text(
        text = text,
        color = resolvedColor,
        style = style
            .copy(fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal),
        modifier = modifier,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyTiny(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.body.tiny,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyTiny(
    annotatedString: AnnotatedString,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = annotatedString,
        style = LocalAppTheme.current.textStyle.body.tiny,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodySmall(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.body.small,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodySmall(
    annotatedString: AnnotatedString,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = annotatedString,
        style = LocalAppTheme.current.textStyle.body.small,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyRegular(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.body.regular,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyRegular(
    annotatedString: AnnotatedString,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = annotatedString,
        style = LocalAppTheme.current.textStyle.body.regular,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyLarge(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.body.large,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextBodyXLarge(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.body.xl,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}

@Composable
fun TextTitleS(
    text: String,
    modifier: Modifier = Modifier,
    bold: Boolean = false,
    maxLines: Int = Int.MAX_VALUE,
    overflow: TextOverflow = TextOverflow.Ellipsis,
    color: (TextThemeColor) -> Color = { it.default },
    textAlign: TextAlign? = null,
    textDecoration: TextDecoration? = null,
    onTextLayout: (TextLayoutResult) -> Unit = {}
) {
    AppText(
        text = text,
        style = LocalAppTheme.current.textStyle.title.s,
        modifier = modifier,
        bold = bold,
        color = color,
        maxLines = maxLines,
        overflow = overflow,
        textAlign = textAlign,
        textDecoration = textDecoration,
        onTextLayout = onTextLayout
    )
}
